if (!customElements.get("page-202610-oct-1")) {
  customElements.define(
    "page-202610-oct-1",
    class Page202610Oct1 extends HTMLElement {
      constructor() {
        super();
        this.$ultimateTabId = '';
        this.$swiper = '';
        this.$isMobile = window.innerWidth <= 768;
      }

      initAnchorEvents() {
        const spans = this.querySelectorAll("[data-apex-anchor-to]");
        spans.forEach((span) => {
          span.addEventListener("click", (e) => {
            const anchorTarget = span.dataset.apexAnchorTo;
            const anchor = this.querySelector(`[data-apex-anchor="${anchorTarget}"]`);
            anchor.scrollIntoView({ behavior: "smooth", block: 'start' });
          });
        });
      }
      initSection3() {
        const section3 = this.querySelector('.section3');
        const swiperContainer = this.querySelector('.section3 .swiper-container');
        const isMobile = this.$isMobile;
        if( isMobile ) {
          this.$swiper = new Swiper(swiperContainer, {
            slidesPerView: 'auto',
            // spaceBetween: 12,
            // loop: true,
            // centeredSlides: true,
            pagination: {
              el: section3.querySelector('.swiper-pagination'),
              clickable: true,
            },
          });
        }
      }
      initSection4() {
        let currentTabId = '';
        const tabButtons = this.querySelectorAll('.section4 .tab-button');
        const tabContents = this.querySelectorAll('.section4 .tab-content');
        const isMobile = this.$isMobile;
        
        if (tabButtons.length > 0) {
          tabButtons.forEach(button => {
            button.addEventListener('click', () => {
              const tabId = button.getAttribute('data-tab');
              if (currentTabId === tabId) {
                return;
              }
              if(isMobile) {
                button.scrollIntoView({behavior: "smooth", block: "nearest", inline: "center"});
              }
              // 移除所有活动状态
              tabButtons.forEach(btn => btn.classList.remove('active'));
              tabContents.forEach(content => content.classList.remove('active'));
              
              // 添加当前活动状态
              button.classList.add('active');
              document.getElementById(`${tabId}`).classList.add('active');
              
              currentTabId = tabId;
            });
          });
        }
      }
      initSection5() {
        let currentTabId = '';
        const tabButtons = this.querySelectorAll('.section5 .tab-button');
        const tabNavigation = this.querySelector('.section5 .tab-navigation');
        const swiperContainer = this.querySelector('.section5 .swiper-container');
        const tabContents = this.querySelectorAll('.section5 .tab-content');
        const isMobile = this.$isMobile;
        if( !isMobile) {
          this.$swiper = new Swiper(swiperContainer, {
            slidesPerView: 4,
            autoHeight: true,
            allowTouchMove: isMobile,
            spaceBetween: 16,
            // autoplay: {
            //   delay: 5000,
            //   disableOnInteraction: false,
            // },
            // breakpoints: {
            //   0: {
            //     slidesPerView: 5,
            //   },
            //   1400: {
            //     slidesPerView: 4,
            //   }
            // },
            navigation: {
              nextEl: tabNavigation.querySelector('.swiper-button-next'),
              prevEl: tabNavigation.querySelector('.swiper-button-prev'),
            },
            observer: true,
            observeParents: true,
            on: {
              init: function() {
                setTimeout(() => this.updateAutoHeight(300), 100);
                if (this.slides.length < 5) {
                  tabNavigation.querySelector('.swiper-button-next').style.display = 'none'
                  tabNavigation.querySelector('.swiper-button-prev').style.display = 'none'
                }
              }
            }
          });
        }
        
        if (tabButtons.length > 0) {
          tabButtons.forEach(button => {
            button.addEventListener('click', () => {
              const tabId = button.getAttribute('data-tab');
              if (currentTabId === tabId) {
                return;
              }
              if(isMobile) {
                button.scrollIntoView({behavior: "smooth", block: "nearest", inline: "center"});
              }
              // 移除所有活动状态
              tabButtons.forEach(btn => btn.classList.remove('active'));
              tabContents.forEach(content => content.classList.remove('active'));
              
              // 添加当前活动状态
              button.classList.add('active');
              document.getElementById(`${tabId}`).classList.add('active');
              
              currentTabId = tabId;
            });
          });
        }
      }
      initSection6() {
        let currentTabId = '';
        const tabButtons = this.querySelectorAll('.section6 .tab-button');
        const tabContents = this.querySelectorAll('.section6 .tab-content');
        const isMobile = this.$isMobile;
        // const pcslides = this.querySelectorAll('.section4 .swiper-container .pc-slide');
        // const mslides = this.querySelectorAll('.section4 .swiper-container .mobile-slide');
        // const list = isMobile ? pcslides : mslides;
        // if( list && list.length ) {
        //   list.forEach( (slide) => {
        //     slide.remove();
        //   })
        // }
        if (tabButtons.length > 0) {
          tabButtons.forEach(button => {
            button.addEventListener('click', () => {
              const tabId = button.getAttribute('data-tab');
              if (currentTabId === tabId) {
                return;
              }
              if(isMobile) {
                button.scrollIntoView({behavior: "smooth", block: "nearest", inline: "center"});
              }
              // 移除所有活动状态
              tabButtons.forEach(btn => btn.classList.remove('active'));
              tabContents.forEach(content => content.classList.remove('active'));
              
              // 添加当前活动状态
              button.classList.add('active');
              document.getElementById(`${tabId}`).classList.add('active');
              
              // 重新初始化当前标签页的Swiper
              this.initSwiperForTab(`${tabId}`);
              currentTabId = tabId;
            });
          });
          
          // 初始化第一个标签页的Swiper
          if (tabContents.length > 0) {
            this.initSwiperForTab(tabContents[0].id);
            currentTabId = tabContents[0].id;
          }
        }
      }
      initSection7() {
        const section7 = this.querySelector('.section7');
        const swiperContainer = this.querySelector('.section7 .swiper-container');
        const isMobile = this.$isMobile;
        if( isMobile ) {
          this.$swiper = new Swiper(swiperContainer, {
            slidesPerView: 'auto',
            spaceBetween: 12,
            // loop: true,
            // centeredSlides: true,
            pagination: {
              el: section7.querySelector('.swiper-pagination'),
              clickable: true,
            },
          });
        }
        this.querySelectorAll(".section7 .item").forEach((item) => {
          const video = item.querySelector("video");
          const btn = item.querySelector(".video-control");
          const playIcon = item.querySelector(".icon-play");
          const pauseIcon = item.querySelector(".icon-pause");
          const progress = item.querySelector(".progress-bar");
          const radius = 14;
          const circumference = 2 * Math.PI * radius;
          progress.style.strokeDasharray = circumference;
          progress.style.strokeDashoffset = circumference;
          // 更新进度条
          video.addEventListener("timeupdate", () => {
            if (!video.duration) return;
            const percent = video.currentTime / video.duration;
            const offset = circumference - percent * circumference;
            progress.style.strokeDashoffset = offset;
          });
          // 播放暂停
          item.addEventListener("click", () => {
            // 先暂停所有视频（推荐）
            this.querySelectorAll(".section7 video").forEach(v => {
              if (v !== video) {
                v.pause();
                v.parentNode.classList.remove("playing");
              }
            });
            this.querySelectorAll(".section7 .item").forEach(i => i.classList.remove("playing"));
            if (video.paused) {
              video.play();
              item.classList.add("playing");
            } else {
              video.pause();
              item.classList.remove("playing");
            }
          });
          // 播放结束重置
          video.addEventListener("ended", () => {
            video.currentTime = 0;
            progress.style.strokeDashoffset = circumference;
            item.classList.remove("playing");
          });
        });
      }
      initSwiperForTab(tabId) {
        const tabContent = document.getElementById(tabId);
        // console.log(tabContent,33)
        if (!tabContent) return;
        
        const swiperContainer = tabContent.querySelector('.swiper-container');
        if (!swiperContainer) return;
        
        if (swiperContainer.swiper) {
          swiperContainer.swiper.destroy();
        }
        const isMobile = this.$isMobile;
        this.$swiper = new Swiper(swiperContainer, {
          slidesPerView: 'auto',
          autoHeight: true,
          allowTouchMove: isMobile,
          spaceBetween: 20,
          // autoplay: {
          //   delay: 5000,
          //   disableOnInteraction: false,
          // },
          breakpoints: {
            768: {
              // navigation: false,
            },
          },
          navigation: {
            nextEl: tabContent.querySelector('.swiper-button-next'),
            prevEl: tabContent.querySelector('.swiper-button-prev'),
          },
          pagination: {
            el: tabContent.querySelector('.swiper-pagination'),
            clickable: true,
          },
          observer: true,
          observeParents: true,
          on: {
            init: function() {
              // console.log(this,222)
              setTimeout(() => this.updateAutoHeight(300), 100);
              const slides = Array.from(this.slides);
              // console.log(this.slides,222)
              if (this.slides.length < 2) {
                tabContent.querySelector('.swiper-button-next').style.display = 'none'
                tabContent.querySelector('.swiper-button-prev').style.display = 'none'
                tabContent.querySelector('.swiper-pagination').style.display = 'none';
              }
              slides.forEach(slide => {
                if (isMobile && slide.classList.contains('pc-slide')) {
                  slide.style.display = 'none';
                } else if (!isMobile && slide.classList.contains('mobile-slide')) {
                  slide.style.display = 'none';
                }
              });
            }
          }
        });
      }

      connectedCallback() {
        document.addEventListener("DOMContentLoaded", () => {
          // this.initSection3();
          this.initSection4();
          if (window.innerWidth > 768) {
          } else {
            // this.initSection3();
          }
        });
      }
    }
  );
}
